export const AFFILIATE_MARKET_TYPES =
    process.env.REACT_APP_AFFILIATE_MARKET_TYPES?.split(",") || [];

export const MARKET_TYPES = {
    NEON: "MARKETPLACE_TO_MYANMAR",
    INTERNATIONAL: "ECOMMERCE_INTERNATIONAL",
    LAZADA: "LAZADA",
    CENTRAL: "CENTRAL"
};
